import { gql } from '@apollo/client';

const QUEUE_DOCUMENT_DOWNLOAD = gql`
  mutation QueueDocumentDownload($request: DocumentAggregateRequestInput!) {
    queueDocumentDownload(request: $request)
  }
`;

export { QUEUE_DOCUMENT_DOWNLOAD };
